import { FileNode, FileType } from "./FileNode";

/* ==----------------------------------------------------------------------------------------------------------== */
/* ==----------------------------------------== Class definitions ==-------------------------------------------== */
/* ==----------------------------------------------------------------------------------------------------------== */

/**
 * @description Represents a file with blob content
 * */
export class BlobNode extends FileNode {
    /**
     * Refer to FileNode.js for description
     * */
    getFileType() {
        return FileType.BLOB;
    }

    /**
     * Refer to FileNode.js for description
     * */
    getContentAsBlob() {
        return this.content;
    }
}
